var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"dynamic-check",attrs:{"name":_vm.name,"disabled":_vm.disabled},model:{value:(_vm.inputData),callback:function ($$v) {_vm.inputData=$$v},expression:"inputData"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }